import jwt_decode from "jwt-decode";
import { getNewAccessToken } from "../utils/apiFunction";
import store from "../store";

export const checkToken = () => {
  var cookieToken = getToken();
  var decoded = jwt_decode(cookieToken);
  if (cookieToken == null || cookieToken == "") {
    store.commit("userVUEX/checkLoginStatus", false);
    return false;
  } else {
    if (Date.now() >= decoded.exp * 1000) {
      return false;
    } else {
      return true;
    }
  }
};
// export default checkToken;

export const checkTokenExpiry = () => {
  let cookieToken = getToken();
  let decoded = jwt_decode(cookieToken);
  let time = null;
  if (Date.now() >= decoded.exp * 1000) {
    time = false;
  } else {
    time = true;
  }
  return time;
};

export const startTokenExpiryWatcher = () => {
  setInterval(async () => {
    if (checkBeforeTokenExpiry()) {
      // Token is expiring within the next 1 minute
      // Refresh the token
      await getNewAccessToken();
    }
  }, 60000); // Check every 1 minute
};

export const checkBeforeTokenExpiry = () => {
  let cookieToken = getToken();
  let decoded = jwt_decode(cookieToken);
  let expirationTime = decoded.exp * 1000;
  let currentTime = Date.now();
  let timeDifference = expirationTime - currentTime;
  if (timeDifference <= 300000 && timeDifference > 0) {
    return true;
  } else {
    return false;
  }
};

export const getToken = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "accessToken") {
        return cur[1];
      }
    }
  }
  return null;
};

export const getRefreshToken = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "refreshToken") {
        return cur[1];
      }
    }
  }
  return null;
};

export const clearCookies = () => {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie =
      // name.trim() + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
      name.trim() + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=hire3x.com;";
  }
};

export const checkAccess = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "collegeDashboard") {
        if (cur[1] === 'no-access') {
          return false;
        } else {
          return true;
        }
      }
    }
  }
  return false;
}

// Remove Token
export const removeToken = () => {
  return localStorage.removeItem("vue_token");
};

export const setToken = (token) => {
  const TokenKey = localStorage.setItem("vue_token", token);
  return TokenKey;
};
